import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import rcon from "../assets/rcon.png";
import { motion } from "framer-motion";
import pg4 from "../assets/pg4.mp3";

const Page4 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  let { round } = rond;
  round = round - 1;
  let roundc = round / 4;

  const toggleMute = () => {
    const audio = document.getElementById("audio");
    audio.muted = !audio.muted;
  };
  return (
    <>
      <div class="fixed top-16 right-8 h-4/5 w-1/6 rounded-xl bg-emerald-100 shadow p-4">
        <div class="text-center">
          <h2 className="text-xl pb-10 pt-4 font-semibold">
            Using Round Constant Table
          </h2>
          <p class="text-sm">
            Now as the final step, we XOR the Subword with the Round constant
            table value.
            <br />
            <br />
            We choose the value from the table according to the round. <br />
            <br />
            Now the XORed value is g(w{round + 3}) which will be used to find w
            {round + 4}
          </p>

          <audio id="audio" controls className="mt-4 w-full">
            <source src={pg4} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <button
            onClick={toggleMute}
            className="mt-2 bg-gray-300 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded"
          >
            Mute
          </button>
        </div>
      </div>
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h1 className="text-3xl font-semibold">Round {roundc + 1}</h1>
          </div>

          <div className="flex flex-col text-xl">
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1.5 }}
            >
              <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
                <b>Step 3:</b>
                <br />
                SubWord (Y): {allResults[1][roundc][0]}{" "}
                {allResults[1][roundc][1]} {allResults[1][roundc][2]}{" "}
                {allResults[1][roundc][3]} <br></br>
                SubWord(Y) ⊕ Rcon({roundc + 1})<br></br>
              </div>
            </motion.div>
          </div>
          <div className="grid grid-cols-2 gap-8 content-center">
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 2.5 }}
            >
              <div className="text-xl">
                <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
                  (Y) ⊕ Rcon(i) = g(W{round + 3})<br></br>
                  g(W{round + 3}) = {allResults[2][roundc][0]}{" "}
                  {allResults[2][roundc][1]} {allResults[2][roundc][2]}{" "}
                  {allResults[2][roundc][3]} <br />
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 3.5 }}
            >
              <div className="row-span-2">
                <img src={rcon} width="400" height="200" alt="sbox"></img>
                <p className=" align-middle bg-cyan-100">
                  Round Constant Table
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page4;
